import { Controller } from 'stimulus';
import getControllerForElement from '@/helpers/getControllerForElement';

class ShippingMethodController extends Controller {
  onShippingMethodChange({ currentTarget }) {
    const { id } = currentTarget.dataset;

    ShippingMethodController.addShippingMethod(id)
      .then(() => this.updateCartSummary());
  }

  updateCartSummary() {
    const cartSummaryEl = document.querySelector('[data-controller*="cart-summary"]');

    getControllerForElement(this.application, cartSummaryEl, 'cart-summary')
      .then((controller) => controller.recalculate());
  }

  static addShippingMethod(id) {
    return $.ajax({
      url: window.app.api.shippingMethod,
      type: 'POST',
      data: {
        shipping_method_id: id,
      },
    });
  }
}

ShippingMethodController.targets = [];

export default ShippingMethodController;
